import "./index.scss";

import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";

import Bay_choice from "./components/bay-choice.js";

import Straight_pole from "./components/straight-pole.js";
import Recess_pole from "./components/recess-pole.js";
import One_bend from "./components/one-bend.js";
import Two_bend from "./components/two-bend.js";
import Square_bend from "./components/square-bend.js";
import Four_bend from "./components/four-bend.js";
import Continuous_curve from "./components/continuous-curve.js";

function Base_layout() {
	if (localStorage.getItem("measurtement_type") === null) {
		localStorage.setItem("measurtement_type", "mm");
	}

	const router = createBrowserRouter([
		{
			element: <Page_wrap />,
			children: [
				{
					path: "/app/bay-checker/straight-pole/",
					element: <Straight_pole />,
				},
				{
					path: "/app/bay-checker/recess-pole/",
					element: <Recess_pole />,
				},
				{
					path: "/app/bay-checker/one-bend/",
					element: <One_bend />,
				},
				{
					path: "/app/bay-checker/two-bend/",
					element: <Two_bend />,
				},
				{
					path: "/app/bay-checker/square-bend/",
					element: <Square_bend />,
				},
				{
					path: "/app/bay-checker/four-bend/",
					element: <Four_bend />,
				},
				{
					path: "/app/bay-checker/continuous-curve/",
					element: <Continuous_curve />,
				},
				{
					path: "*",
					element: <Bay_choice />,
				},
			],
		},
	]);

	return <RouterProvider router={router} />;
}

function Page_wrap() {
	return <Outlet />;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Base_layout />);
